import CheckIcon from '@mui/icons-material/Check';
import { FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { HelperText } from '@components';

interface ControlledCheckboxProps {
  fields: { [key: string]: string };
  name: string;
  handleCheckboxChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    key: string
  ) => void;
}

export const ControlledCheckbox = ({
  fields,
  name,
  handleCheckboxChange,
}: ControlledCheckboxProps) => {
  const { control, watch } = useFormContext();
  const values = watch(name) || [];
  const { t } = useTranslation('common');

  return (
    <FormGroup>
      <HelperText>{t('selectMultiple')}</HelperText>
      {Object.entries(fields).map(([key, label]) => (
        <Controller
          key={key}
          name={name}
          control={control}
          render={() => (
            <FormControlLabel
              value={key}
              control={
                <Checkbox
                  id={key}
                  name={key}
                  checked={
                    Array.isArray(values) ? values.includes(key) : !!values[key]
                  }
                  onChange={(e) => handleCheckboxChange(e, key)}
                  checkedIcon={<CheckIcon />}
                  sx={(theme) => ({
                    mx: 1,

                    '& .MuiSvgIcon-root': {
                      fill: 'transparent',
                      border: `2px solid ${theme.palette.brandGray.main}`,
                      borderRadius: 1,
                    },

                    '&.Mui-checked .MuiSvgIcon-root': {
                      fill: theme.palette.primary.main,
                      border: `2px solid ${theme.palette.primary.main}`,
                    },
                  })}
                  inputProps={
                    {
                      'data-cy': name + 'Checkbox',
                    } as React.InputHTMLAttributes<HTMLInputElement>
                  }
                  disableRipple
                  disabled={key !== 'none' && !!values['none']}
                />
              }
              label={label}
            />
          )}
        />
      ))}
    </FormGroup>
  );
};
